   import React, { useState, useEffect } from "react";
import { FaHandshake } from "react-icons/fa";
import MyPage from "../components/MyPage";

function Gallery() {
  const [activeYear, setActiveYear] = useState("all");
  const [photos, setPhotos] = useState([]);
  const [limit, setLimit] = useState("all");
  const [previewImg, setPreviewImg] = useState(null);

  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/allgallery.json")
      .then((res) => res.json())
      .then((data) => setPhotos(data));

    // ✅ XML → proof only
    fetch("/api/allgallery.xml")
      .then((res) => res.text())
      .then(() => console.log("Gallery XML loaded"));
  }, []);

  const years = [
    "all",
    2006, 2007, 2008, 2009, 2010,
    2011, 2012, 2013, 2014, 2015,
    2016, 2017, 2018, 2019, 2020,
    2021, 2022, 2023, 2024, 2025,
    "Farewell"
  ];

  const filteredPhotos =
    activeYear === "all"
      ? photos
      : photos.filter(
          (p) =>
            String(p.year).toLowerCase() ===
            String(activeYear).toLowerCase()
        );

  const finalPhotos =
    limit === "all"
      ? filteredPhotos
      : filteredPhotos.slice(0, Number(limit));

  return (
    <>
      {/* ✅ SEO SAME – NO API */}
      <MyPage
        title="Gallery | Thrissur Jilla Pravasi Kootayma"
        description="Gallery of memorable moments, events, and activities of Thrissur Jilla Pravasi Kootayma."
        keywords="Thrissur Pravasi gallery, events, cultural activities"
      />

      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner">
        <div className="inner-overlay"></div>
        <div className="inner-content slide-down">
          <h1>Gallery</h1>
        </div>
        <div className="breadcrumb slide-up">
          Home / <span>Gallery</span>
        </div>
      </section>

      {/* ===== GALLERY SECTION ===== */}
      <section className="gallery-section">
        <div className="gallery-header">
          <div className="left">
            <h2>
              <FaHandshake /> Our Moments
            </h2>
            <p>Memorable moments captured through photos.</p>
          </div>

          <div className="right">
            {/* LIMIT */}
            <select
              className="year-dropdown limit-dropdown"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >
              <option value="all">All Photos</option>
              <option value="5">1 - 5</option>
              <option value="10">1 - 10</option>
              <option value="20">1 - 20</option>
              <option value="50">1 - 50</option>
            </select>

            {/* YEAR */}
            <select
              className="year-dropdown"
              value={activeYear}
              onChange={(e) => setActiveYear(e.target.value)}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y === "all" ? "Select Year" : y}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="gallery-grid">
          {finalPhotos.map((img, index) => (
            <div className="gallery-card fade-up" key={index}>
              <img
                src={img.src}
                alt={`Gallery ${img.year}`}
                onClick={() => setPreviewImg(img.src)}
              />
            </div>
          ))}

          {filteredPhotos.length === 0 && (
            <p className="no-data">No photos available</p>
          )}
        </div>
      </section>

      {/* ===== IMAGE PREVIEW ===== */}
      {previewImg && (
        <div className="img-preview" onClick={() => setPreviewImg(null)}>
          <span className="close-btn">×</span>
          <img src={previewImg} alt="Preview" />
        </div>
      )}


      {/* ===== CSS ===== */}
      <style>{`
/* ================= PAGE LOAD ANIMATIONS ================= */
@keyframes slideLeft {
  from { opacity: 0; transform: translateX(-80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideRight {
  from { opacity: 0; transform: translateX(80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.slide-left { animation: slideLeft 1s ease forwards; }
.slide-right { animation: slideRight 1s ease forwards; }
.slide-up { animation: slideUp 1s ease forwards; }
.slide-down { animation: slideDown 1s ease forwards; }

.fade-up {
  opacity: 0;
  animation: fadeUp 0.8s ease forwards;
}

/* IMAGE DELAYS */
.delay-0 { animation-delay: 0.1s; }
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.3s; }
.delay-3 { animation-delay: 0.4s; }
.delay-4 { animation-delay: 0.5s; }
.delay-5 { animation-delay: 0.6s; }

/* ===== INNER BANNER ===== */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}

/* ===== GALLERY SECTION ===== */
.gallery-section {
  padding: 90px 80px;
  background: #fff;
}

.gallery-header {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
}

.gallery-header h2 {
  font-size: 34px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.gallery-header h2 span {
  width: 60px;
  height: 2px;
  background: #000;
}

.gallery-header p {
  font-size: 15px;
  margin-top: 8px;
  color: #333;
}

/* BUTTONS */
.gallery-header .right {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.gallery-header button,
.year-dropdown {
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  background: var(--primary-color);
  color: #000;
  height: 40px;
  margin-top: 70px;
}

/* GRID */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.gallery-card {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.gallery-card img {
  width: 100%;
  height: 350px;
  object-fit: cover;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .gallery-section {
    padding: 50px 20px;
  }

  .gallery-header {
    flex-direction: column;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }
    @media (max-width: 768px) {
    .inner-content h1 {
        font-size: 36px;
    }
}

  .breadcrumb {
    left: 16px;
    bottom: -20px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
  /* ===== YEAR DROPDOWN WHITE FIX ===== */
.year-dropdown {
  background: var(--primary-color);
  color: #000;
}

.year-dropdown option {
  background: #fff;   /* white background */
  color: #000;        /* black text */
}
  /* ===== LIMIT DROPDOWN SPACING ===== */
.limit-dropdown {
  margin-right:10px;
}

/* ===== IMAGE PREVIEW MODAL ===== */
.img-preview {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.img-preview img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(255,255,255,0.3);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
}

      `}</style>
    </>
  );
}

export default Gallery;
